import { cn } from '@/lib/utils'

/**
 * The references' link/button arrow: it slides 4px in its direction when the
 * nearest `.group` ancestor is hovered, over 200ms.
 *
 * Extracted 2026-08-08. It previously existed as a local helper inside
 * pricing/page.tsx and was copy-pasted inline 11 more times across about and
 * platform — a page file cannot be imported from, so every other surface
 * re-typed the same span.
 *
 * Decorative by definition: the adjacent label carries the meaning, so this
 * is always aria-hidden.
 */
export function Arrow({
  direction = 'right',
  className,
}: {
  direction?: 'right' | 'left' | 'down' | 'up-right'
  className?: string
}) {
  const glyph =
    direction === 'down'
      ? '↓'
      : direction === 'up-right'
        ? '↗'
        : direction === 'left'
          ? '←'
          : '→'
  const move =
    direction === 'down'
      ? 'group-hover:translate-y-[4px]'
      : direction === 'left'
        ? 'group-hover:-translate-x-[4px]'
        : 'group-hover:translate-x-[4px]'

  return (
    <span
      aria-hidden='true'
      className={cn(
        'inline-block transition-transform duration-200',
        move,
        className
      )}
    >
      {glyph}
    </span>
  )
}

export default Arrow
